/**
 * 声音警报工具
 * 用于在扫描页面发生错误时播放声音提示
 */

/**
 * 播放错误警报声音 (du du du)
 * 使用 Web Audio API 生成蜂鸣声
 */
export const playErrorSound = () => {
  try {
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    
    // 播放三次蜂鸣声 (du du du)
    const beepCount = 3;
    const beepDuration = 0.15; // 每次蜂鸣持续时间（秒）
    const beepGap = 0.1; // 蜂鸣间隔（秒）
    const frequency = 800; // 频率 (Hz)
    
    for (let i = 0; i < beepCount; i++) {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      oscillator.frequency.value = frequency;
      oscillator.type = 'sine';
      
      const startTime = audioContext.currentTime + (i * (beepDuration + beepGap));
      const stopTime = startTime + beepDuration;
      
      // 设置音量渐变以避免爆音
      gainNode.gain.setValueAtTime(0, startTime);
      gainNode.gain.linearRampToValueAtTime(0.3, startTime + 0.01);
      gainNode.gain.setValueAtTime(0.3, stopTime - 0.01);
      gainNode.gain.linearRampToValueAtTime(0, stopTime);
      
      oscillator.start(startTime);
      oscillator.stop(stopTime);
    }
  } catch (error) {
    console.error('播放错误声音失败:', error);
  }
};

/**
 * 播放成功提示声音
 */
export const playSuccessSound = () => {
  try {
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    oscillator.frequency.value = 1200;
    oscillator.type = 'sine';
    
    const startTime = audioContext.currentTime;
    const stopTime = startTime + 0.1;
    
    gainNode.gain.setValueAtTime(0, startTime);
    gainNode.gain.linearRampToValueAtTime(0.2, startTime + 0.01);
    gainNode.gain.setValueAtTime(0.2, stopTime - 0.01);
    gainNode.gain.linearRampToValueAtTime(0, stopTime);
    
    oscillator.start(startTime);
    oscillator.stop(stopTime);
  } catch (error) {
    console.error('播放成功声音失败:', error);
  }
};

